import React from 'react';
import BroadcastOnPersonalOutlinedIcon from '@mui/icons-material/BroadcastOnPersonalOutlined';
import Typography from '@mui/material/Typography';
import Constants from 'style/constants';

import './devices-column.scss';

type Props = {
  deviceLength: number;
};

const DevicesColumn = ({ deviceLength }: Readonly<Props>): React.JSX.Element => {
  const color = deviceLength === 0 ? Constants.Colors.inactive : Constants.Colors.primary;

  return (
    <div className="device-column-container">
      <BroadcastOnPersonalOutlinedIcon className="device-icon" sx={{ color }} />
      {deviceLength > 1 && (
        <Typography variant="body2" sx={{ color: Constants.Colors.primary }}>
          ({deviceLength})
        </Typography>
      )}
    </div>
  );
};

export default DevicesColumn;
